import { BROWSERS } from "../../enums/browser-enums";
import "./IconBrowsers.scss";

type Props = {
  browser: BROWSERS;
};
export const IconBrowsers = ({ browser = BROWSERS.CHROME }: Props) => {
  return <span className={`icon-browsers__${browser}`}></span>;
};
